function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckRoundGray = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none",
  viewBox: "0 0 20 20"
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "#949494",
  d: "M14.895 8.202a.6.6 0 1 0-.79-.904l-5.578 4.88-2.603-2.602a.6.6 0 1 0-.848.848l3 3a.6.6 0 0 0 .82.027z",
  style: {
    fill: "#949494",
    fill: "color(display-p3 .5792 .5792 .5792)",
    fillOpacity: 1
  }
}), /*#__PURE__*/React.createElement("path", {
  fill: "#949494",
  fillRule: "evenodd",
  d: "M10 20c5.523 0 10-4.477 10-10S15.523 0 10 0 0 4.477 0 10s4.477 10 10 10m8.8-10a8.8 8.8 0 1 1-17.6 0 8.8 8.8 0 0 1 17.6 0",
  clipRule: "evenodd",
  style: {
    fill: "#949494",
    fill: "color(display-p3 .5792 .5792 .5792)",
    fillOpacity: 1
  }
}));
export { SvgCheckRoundGray as ReactComponent };